import { SelectWithLabel } from '@adotel/components'
import { MenuItem } from '@material-ui/core'

import {
  showsPaymentType,
  supportsBnpl
} from '../../helpers/gatewayPaymentType'
import { getTranslate } from '../../localization'
import { GatewayPaymentType } from '../../types/gateway'

interface GatewayPaymentTypeSelectProps {
  gatewaysType: string
  value?: GatewayPaymentType
  onChange: (value: GatewayPaymentType) => void
  disabled?: boolean
}

const isPaymentType = (value: unknown): value is GatewayPaymentType =>
  value === 'CASH' || value === 'BNPL'

// Shown only for gateway types that offer BNPL, or for a gateway that is already BNPL. An
// unset value displays as Cash, which is what the server stores for it.
const GatewayPaymentTypeSelect: React.FC<GatewayPaymentTypeSelectProps> = ({
  gatewaysType,
  value,
  onChange,
  disabled
}) => {
  if (!showsPaymentType(gatewaysType, value)) {
    return null
  }

  return (
    <SelectWithLabel
      label={getTranslate('Payment Type')}
      name="basicDetails.paymentType"
      fullWidth
      value={value ?? 'CASH'}
      onChange={(event: { target: { value: unknown } }) => {
        if (isPaymentType(event.target.value)) {
          onChange(event.target.value)
        }
      }}
      size="small"
      disabled={disabled}
      helpertext={
        value === 'BNPL' && !supportsBnpl(gatewaysType)
          ? getTranslate(
              'Change the payment type to Cash before choosing a gateway type without Buy Now, Pay Later'
            )
          : undefined
      }>
      <MenuItem key="CASH" value="CASH">
        {getTranslate('Cash')}
      </MenuItem>
      <MenuItem key="BNPL" value="BNPL" disabled={!supportsBnpl(gatewaysType)}>
        {getTranslate('Buy Now, Pay Later')}
      </MenuItem>
    </SelectWithLabel>
  )
}
export default GatewayPaymentTypeSelect
